import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import BottomNav from "./BottomNav";
import RadialMenu from "./RadialMenu";

export default function MainLayout({ children }) {
  const location = useLocation();
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "null");

  const isAdmin =
    currentUser?.is_admin === 1 ||
    currentUser?.email === "admin@live-evo.com";

  const isStoryPage = location.pathname.startsWith("/story");

  // ✅ NOUVELLE RÈGLE : UNIQUEMENT SUR PROFIL
  const isProfilePage = location.pathname.startsWith("/user/");

  return (
    <div
      className="app-layout"
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      {/* SIDEBAR → partout sauf story */}
      {!isStoryPage && (
        <Sidebar currentUser={currentUser} isAdmin={isAdmin} />
      )}

      {/* ✅ RADIAL MENU → UNIQUEMENT SUR PROFIL */}
      {!isStoryPage && isProfilePage && <RadialMenu />}

      <div
        className="app-content"
        style={{
          flexGrow: 1,
          width: "100%",
          overflowY: "auto",
        }}
      >
        {children}
      </div>

      {/* BOTTOM NAV → partout sauf story */}
      {!isStoryPage && <BottomNav />}
    </div>
  );
}
